app.service('carouselSlider', function (_, console) {
	// TODO: wydzielić jako plugin jQuery i umożliwić skuteczniejsze instancjonowanie.
	let $self, $carouselTrack, $carouselItems;
	let isInit = false;
	let carouselElementsData = [];
	let carouselScrollSteps = [];

	function getTrackMaxScrollLeft($carouselSlider, $carouselTrack) {
		return Math.max(0, $carouselTrack[0].scrollWidth - $carouselSlider[0].offsetWidth);
	}

	function buildScrollSteps($carouselSlider, elementsData) {
		const $carouselTrack = $('.carousel-track', $carouselSlider);
		const maxScrollLeft = getTrackMaxScrollLeft($carouselSlider, $carouselTrack);
		const steps = [];

		if (!elementsData || !elementsData.length) {
			return steps;
		}

		elementsData.forEach(function (elementData) {
			const scrollLeft = Math.min(elementData.offsetLeft, maxScrollLeft);
			if (steps.indexOf(scrollLeft) === -1) {
				steps.push(scrollLeft);
			}
		});

		if (steps.indexOf(maxScrollLeft) === -1) {
			steps.push(maxScrollLeft);
		}

		return steps.sort(function (left, right) {
			return left - right;
		});
	}

	function setScrollStep($carouselTrack, stepIndex) {
		if (stepIndex > 0) {
			$carouselTrack.attr('data-scroll', stepIndex);
		} else {
			$carouselTrack.removeAttr('data-scroll');
		}
	}

	function getClosestScrollStepIndex(scrollSteps, scrollLeft) {
		let closestIndex = 0;
		let closestDistance = Number.POSITIVE_INFINITY;

		scrollSteps.forEach(function (stepLeft, index) {
			const distance = Math.abs(stepLeft - scrollLeft);
			if (distance < closestDistance) {
				closestDistance = distance;
				closestIndex = index;
			}
		});

		return closestIndex;
	}

	function getMultiScrollPageSteps($carouselSlider, $carouselTrack) {
		const sliderWidth = $carouselSlider[0].offsetWidth;
		const maxScrollLeft = getTrackMaxScrollLeft($carouselSlider, $carouselTrack);
		const steps = [0];

		if (!sliderWidth) {
			return steps;
		}

		for (let stepLeft = sliderWidth; stepLeft < maxScrollLeft; stepLeft += sliderWidth) {
			steps.push(stepLeft);
		}

		if (steps[steps.length - 1] !== maxScrollLeft) {
			steps.push(maxScrollLeft);
		}

		return steps;
	}

	function getMultiScrollPageCount($carouselSlider, $carouselTrack) {
		return getMultiScrollPageSteps($carouselSlider, $carouselTrack).length - 1;
	}

	function getMultiScrollStepIndex($carouselSlider, $carouselTrack, scrollLeft) {
		const pageSteps = getMultiScrollPageSteps($carouselSlider, $carouselTrack);
		return getClosestScrollStepIndex(pageSteps, scrollLeft);
	}

	/**
	 * Oblicza liczbę elementów znajdujących się poza widocznym obszarem slidera
	 * @param {Array} elementsData - tablica danych elementów
	 * @param {number} visibleRightEdge - prawa krawędź aktualnie widocznego obszaru
	 * @returns {number} liczba elementów poza widokiem
	 */
	function calculateOverflowedElements(elementsData, visibleRightEdge) {
		if (!elementsData || elementsData.length === 0) {
			return 0;
		}

		let overflowCount = 0;
		for (let i = 0; i < elementsData.length; i++) {
			const element = elementsData[i];
			if (element.offsetToRight > visibleRightEdge + 1) {
				overflowCount++;
			}
		}
		return overflowCount;
	}

	/**
	 * Przelicza i aktualizuje dane overflow dla slidera
	 * @param {jQuery} $carouselSlider - element slidera
	 */
	function recalculateOverflow($carouselSlider) {
		const $carouselTrack = $('.carousel-track', $carouselSlider);
		const carouselInitTimestamp = $carouselTrack.attr('data-carousel-init-timestamp');

		if (!carouselInitTimestamp || !carouselElementsData[carouselInitTimestamp]) {
			return;
		}

		const boxWidth = $carouselSlider[0].offsetWidth;
		const currentScrollLeft = $carouselTrack[0].scrollLeft || 0;
		const visibleRightEdge = currentScrollLeft + boxWidth;
		const overflowedCount = calculateOverflowedElements(carouselElementsData[carouselInitTimestamp], visibleRightEdge);

		$carouselTrack.attr('data-overflowed-elements', overflowedCount);
	}

	/**
	 * Odświeża dane wszystkich elementów (np. po dynamicznym dodaniu nowych elementów)
	 * @param {jQuery} $carouselSlider - element slidera
	 */
	function refreshElementsData($carouselSlider) {
		const $carouselTrack = $('.carousel-track', $carouselSlider);
		const $carouselItems = $('.carousel-item', $carouselSlider);
		const carouselInitTimestamp = $carouselTrack.attr('data-carousel-init-timestamp');

		if (!carouselInitTimestamp) {
			return;
		}

		// Wyczyść stare dane
		carouselElementsData[carouselInitTimestamp] = [];

		// Zbierz aktualne dane wszystkich elementów
		$carouselItems.each(function (index, el) {
			const offsetLeft = el.offsetLeft;
			const width = el.offsetWidth;
			const offsetToRight = offsetLeft + width;

			carouselElementsData[carouselInitTimestamp].push({
				carouselInitTimestamp: carouselInitTimestamp,
				offsetLeft: offsetLeft,
				width: width,
				offsetToRight: offsetToRight,
				index: index,
				element: el
			});
		});
		carouselScrollSteps[carouselInitTimestamp] = buildScrollSteps($carouselSlider, carouselElementsData[carouselInitTimestamp]);

		// Przelicz overflow z aktualnymi danymi
		recalculateOverflow($carouselSlider);

		const elementsData = carouselElementsData[carouselInitTimestamp];
		console.log('refreshElementsData', {
			timestamp: new Date().toISOString(),
			totalItems: $carouselItems.length,
			sliderWidth: $carouselSlider[0].offsetWidth,
			trackScrollWidth: $carouselTrack[0].scrollWidth,
			scrollSteps: carouselScrollSteps[carouselInitTimestamp],
			elementsData: elementsData.map((e, i) => ({
				index: i,
				offsetLeft: e.offsetLeft,
				width: e.width,
				offsetToRight: e.offsetToRight
			}))
		});
	}

	function setInfoForSlider($carouselSlider) {
		const $carouselTrack = $('.carousel-track', $carouselSlider); // lista z elementami slidera, która jest przesuwana
		const $carouselItems = $('.carousel-item', $carouselSlider);
		const carouselInitTimestamp = Date.now();
		$carouselTrack.attr('data-carousel-init-timestamp', carouselInitTimestamp);
		const scroll = $carouselTrack.attr('data-scroll') / 1 || 0;
		const boxWidth = $carouselSlider[0].offsetWidth;
		let carouselScroll = 0;
		carouselElementsData[carouselInitTimestamp] = [];

		// Zbierz dane wszystkich elementów
		$carouselItems.each(function (index, el) {
			carouselElementsData[carouselInitTimestamp].push({
				carouselInitTimestamp: carouselInitTimestamp,
				offsetLeft: el.offsetLeft,
				width: el.offsetWidth,
				offsetToRight: el.offsetLeft + el.offsetWidth,
			})
		});
		carouselScrollSteps[carouselInitTimestamp] = buildScrollSteps($carouselSlider, carouselElementsData[carouselInitTimestamp]);

		// Przelicz liczbę elementów poza widokiem
		const overflowedCarouselElementsCount = calculateOverflowedElements(
			carouselElementsData[carouselInitTimestamp],
			boxWidth
		);

		$carouselTrack.attr('data-overflowed-elements', overflowedCarouselElementsCount);

		console.log('setInfoForSlider', {
			sliderWidth: boxWidth,
			totalItems: $carouselItems.length,
			overflowedItems: overflowedCarouselElementsCount,
			currentScroll: scroll,
			visibleOverflow: overflowedCarouselElementsCount,
			scrollSteps: carouselScrollSteps[carouselInitTimestamp],
			elementsData: carouselElementsData[carouselInitTimestamp]
		});

		if (carouselScroll) {
			slide(carouselScroll);
		}
	}

	function slide($el, direction) {
		const $carouselSlider = $el.closest('.carousel-slider');
		const $carouselTrack = $carouselSlider.find('.carousel-track');
		const carouselInitTimestamp = $carouselTrack.attr('data-carousel-init-timestamp');
		let elementsData = carouselElementsData[carouselInitTimestamp];
		let scrollSteps = carouselScrollSteps[carouselInitTimestamp] || [];

		if (!elementsData || elementsData.length === 0) {
			console.warn('slide: brak danych elementów');
			return;
		}

		let scroll = $carouselTrack.attr('data-scroll') / 1 || 0;

		// Odśwież dane jeśli idziemy do ostatniego elementu (mogą być nowe elementy)
		if (direction > 0 && scroll >= scrollSteps.length - 2) {
			refreshElementsData($carouselSlider);
			elementsData = carouselElementsData[carouselInitTimestamp];
			scrollSteps = carouselScrollSteps[carouselInitTimestamp] || [];
		}

		const maxScroll = scrollSteps.length - 1;
		const newScroll = scroll + direction;

		// Sprawdź granice scrollowania
		if (newScroll < 0 || newScroll > maxScroll) {
			console.log('slide: poza granicami', { newScroll, maxScroll });
			return;
		}

		scroll = newScroll;
		const scrollPosition = scrollSteps[scroll];

		setScrollStep($carouselTrack, scroll);
		$carouselTrack[0].scrollLeft = scrollPosition;

		// Przelicz overflow po zmianie pozycji
		recalculateOverflow($carouselSlider);

		console.log('slide', {
			direction,
			scroll,
			maxScroll,
			scrollLeft: scrollPosition,
			scrollSteps: scrollSteps,
			actualTrackScrollLeft: $carouselTrack[0].scrollLeft,
			trackScrollWidth: $carouselTrack[0].scrollWidth
		});
	}

	function slideByPage($el, direction) {
		const $carouselSlider = $el.closest('.carousel-slider');
		const $carouselTrack = $carouselSlider.find('.carousel-track');
		const carouselInitTimestamp = $carouselTrack.attr('data-carousel-init-timestamp');
		let elementsData = carouselElementsData[carouselInitTimestamp];

		if (!elementsData || elementsData.length === 0) {
			return;
		}

		const maxScrollLeft = getTrackMaxScrollLeft($carouselSlider, $carouselTrack);
		let pageSteps = getMultiScrollPageSteps($carouselSlider, $carouselTrack);
		let scroll = getMultiScrollStepIndex($carouselSlider, $carouselTrack, $carouselTrack[0].scrollLeft || 0);
		const maxScroll = pageSteps.length - 1;
		const newScroll = scroll + direction;

		if (newScroll < 0 || newScroll > maxScroll) {
			return;
		}

		scroll = newScroll;
		let newScrollLeft = pageSteps[scroll];

		// Odśwież dane jeśli idziemy do końca
		if (direction > 0 && newScrollLeft >= maxScrollLeft * 0.9) {
			refreshElementsData($carouselSlider);
			elementsData = carouselElementsData[carouselInitTimestamp];
			pageSteps = getMultiScrollPageSteps($carouselSlider, $carouselTrack);
			newScrollLeft = pageSteps[scroll];
		}

		$carouselTrack[0].scrollLeft = newScrollLeft;
		setScrollStep($carouselTrack, scroll);
		recalculateOverflow($carouselSlider);

		console.log('slideByPage', {
			direction,
			newScrollLeft,
			scroll,
			maxScroll,
			pageSteps,
			maxScrollLeft
		});
	}

	function checkOnTabKey($el) {
		if ($el && $el.length) {
			const $carouselSlider = $el.closest('.carousel-slider');
			const $carouselTrack = $carouselSlider.find('.carousel-track');
			const flexGap = 0; // flex gap 0px dla elementów
			const item = $el[0].getBoundingClientRect();
			const slider = $carouselSlider[0].getBoundingClientRect(); // statyczny element z overflow:hidden
			if (item.x < slider.x) {
				console.log('Tabowanie w lewo');
				slide($el, -1);
			} else if (item.x + item.width + flexGap > slider.x + slider.width) { // sprawdzamy czy element już wychodzi poza widoczny obszar slidera, odejmując padding i flex gap
				console.log('Tabowanie w prawo');
				if ($carouselTrack.attr('data-overflowed-elements') > 0) {
					slide($el, 1);
				}
			}
		}
	}
	function nextSlideOnKeyup(e) {
		const $el = $(e.target);
		if (e.key == 'Tab') {
			e.preventDefault();
			e.stopPropagation();
			checkOnTabKey($el);
		}
	}
	function setEvents($carouselSlider) {
		const isMultiMode = $carouselSlider.attr('data-scroll-mode') === 'multi';

		$carouselSlider.on('keyup', '.carousel-item', function (e) {
			nextSlideOnKeyup(e); // tab zawsze single
		}).on('click', '.js-carousel-slide-left', function () {
			if (isMultiMode) {
				slideByPage($(this), -1);
			} else {
				slide($(this), -1);
			}
		}).on('click', '.js-carousel-slide-right', function () {
			if (isMultiMode) {
				slideByPage($(this), 1);
			} else {
				slide($(this), 1);
			}
		});

		const $carouselTrack = $carouselSlider.find('.carousel-track');
		const carouselInitTimestamp = $carouselTrack.attr('data-carousel-init-timestamp');

		// Obserwuj zmiany w .carousel-track aby automatycznie odświeżyć dane elementów
		const observer = new MutationObserver(_.debounce(function (mutations) {
			console.log('MutationObserver: wykryto zmianę', mutations.length);
			refreshElementsData($carouselSlider);
		}, 300));

		observer.observe($carouselTrack[0], {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['style', 'class']
		});

		// Przechowaj referencję do observera aby móc go później zatrzymać
		$carouselTrack.data('mutationObserver', observer);

		// Obserwuj zmiany rozmiaru okna
		const resizeObserver = new ResizeObserver(_.debounce(function () {
			console.log('ResizeObserver: zmiana rozmiaru');
			refreshElementsData($carouselSlider);
		}, 300));

		resizeObserver.observe($carouselSlider[0]);
		$carouselTrack.data('resizeObserver', resizeObserver);

		function carouselTrackScroll() {
			// Aktualizacja statusu slidera podczas scrollowania, aby pokazać/ukryć przyciski nawigacyjne
			const elementsData = carouselElementsData[carouselInitTimestamp];
			const scrollSteps = carouselScrollSteps[carouselInitTimestamp] || [];
			const isMultiMode = $carouselSlider.attr('data-scroll-mode') === 'multi';
			if (!elementsData || elementsData.length === 0) {
				return;
			}

			const currentScrollLeft = $carouselTrack[0].scrollLeft;
			if (!isMultiMode && !scrollSteps.length) {
				return;
			}
			const scrollIndex = isMultiMode
				? getMultiScrollStepIndex($carouselSlider, $carouselTrack, currentScrollLeft)
				: getClosestScrollStepIndex(scrollSteps, currentScrollLeft);
			setScrollStep($carouselTrack, scrollIndex);

			// Przelicz liczbę elementów poza widokiem
			recalculateOverflow($carouselSlider);
		}

		$carouselTrack.on('scroll', _.debounce(carouselTrackScroll, 250));
	}

	function init($carouselSlider) {
		if (!$carouselSlider.length) { // główny element slidera, który zawiera track i itemy domyślnie powinien to element z klasą .carousel-slider
			return;
		}
		setInfoForSlider($carouselSlider);
		if ($carouselSlider.hasClass('events-initialized')) {
			return;
		} else {
			$carouselSlider.addClass('events-initialized');
			setEvents($carouselSlider);
		}
	}

	return {
		init
	};
});
